module.exports = __webpack_public_path__ + "static/img/03_gesundheit_spw_plakatprasentation_304x204mm.542dbff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spoe/03_gesundheit_spw_plakatprasentation_304x204mm.jpg
// module id = 201
// module chunks = 1